<template lang="pug">
    div.schedule-editor-control
        div.schedule-editor-control__head
            div Post Schedule

        datetime-field(label="Post Date and Time" v-model="scheduleDateTime" :minDate="minDate" :disabled="disabled")
        re-toast-alert(v-if="disabled" message="Post cannot be rescheduled." type="warning")
</template>

<script>
import Moment from 'moment'

export default {
    name: 'schedule-editor-control',

    props: {
        value: {
            type: Object,
        },
        disabled: {
            type: Boolean,
        },
    },

    data() {
        return {
            scheduleDateTime: null,
            minDate: null,
        }
    },

    watch: {
        value: {
            handler() {
                this.updateFromProp()
            },
            deep: true,
        },
    },

    methods: {
        updateFromProp() {
            const d = this.value || {}
            this.scheduleDateTime = d.scheduleDateTime || null
            
            if (this.scheduleDateTime && Moment(this.scheduleDateTime) < Moment()) {
                this.minDate = this.scheduleDateTime
            }
            else {
                this.minDate = new Date()
            }
        },

        apply() {
            const val = {
                enabled: !!this.scheduleDateTime,
                scheduleDateTime: this.scheduleDateTime,
            }

            this.$emit('input', val)
            this.$emit('change', val)
        },
    },

    mounted() {
        this.updateFromProp()
    },
}
</script>
